import { useState, useEffect, useRef } from 'react';

import styles from './index.module.scss';
import { roundFloat } from '@/utils/common';

import { useGlobal } from '@/utils/useGlobal';

let videoSceneE: any = null,
    textSceneE: any = null;

async function transformToBob(url: string): Promise<string> {
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch video: ${response.status}`);
    }

    const blob = await response.blob();

    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
}
export default function Effortlessly() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.Effortlessly');
    const videoRefPC: any = useRef();
    const videoRefH5: any = useRef();
    const [isEnterA, setIsInterA] = useState(false);
    const [isEnterA2, setIsInterA2] = useState(false);
    const [isEnterB, setIsInterB] = useState(false);
    const [isEnterB2, setIsInterB2] = useState(false);
    const [isEnterC, setIsInterC] = useState(false);
    let innerHeight = 1080;

    if (typeof window !== 'undefined') {
        innerHeight = window?.innerHeight;
    }

    const initVideoSrcFnPc = async () => {
        const url = 'https://websiteoss.ecoflow.com/upload/video/1769067147197/effortlessly_video_1.mp4';
        try {
            const blobUrl: any = await transformToBob(url);
            videoRefPC.current.src = blobUrl;
        } catch (error: any) {
            videoRefPC.current.src = url;
        }
    };
    const initVideoSrcFnH5 = async () => {
        const url = 'https://websiteoss.ecoflow.com/upload/video/1769067085884/effortlessly_video_1_h5.mp4';
        try {
            const blobUrl = await transformToBob(url);
            videoRefH5.current.src = blobUrl;
            videoRefH5.current.pause();
            videoRefH5.current.currentTime = 0;
        } catch (error: any) {
            videoRefH5.current.src = url;
        }
    };

    useEffect(() => {
        const AniContainer = window?.AniContainer;

        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (videoSceneE) {
                    AniContainer.removeScene(videoSceneE);
                    videoSceneE = null;
                }
                if (textSceneE) {
                    AniContainer.removeScene(textSceneE);
                    textSceneE = null;
                }

                const isPC = window?.innerWidth > 1024;
                const video: any = isPC ? videoRefPC?.current : videoRefH5?.current;

                const startA = 0.08;
                const startA2 = 0.11;
                const startB = 0.3;
                const startB2 = 0.54;
                const startC = 0.8;
                videoSceneE = AniContainer.create({
                    triggerElement: '.effortlessly-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: '450%',
                    scrollUpdatePos: true,
                    onProcess: (process: number) => {
                        try {
                            const duration: number = video?.duration;
                            if (isNaN(duration)) return;
                            let currentTime = roundFloat(duration * process, 2) || 0;
                            currentTime = Math.round(currentTime * 100) / 100;
                            if (process < startA) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startA && process < startA2) {
                                setIsInterA(true);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startA2 && process < startB) {
                                setIsInterA(false);
                                setIsInterA2(true);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startB && process < startB2) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(true);
                                setIsInterB2(false);
                                setIsInterC(false);
                            } else if (process >= startB2 && process < startC) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(true);
                                setIsInterC(false);
                            } else if (process >= startC) {
                                setIsInterA(false);
                                setIsInterA2(false);
                                setIsInterB(false);
                                setIsInterB2(false);
                                setIsInterC(true);
                            }
                            // video?.setCurrentTime(currentTime);
                            video.currentTime = currentTime;
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    onLazyLoad: async () => {
                        try {
                            const isPC = window?.innerWidth > 1024;
                            if (isPC) {
                                initVideoSrcFnPc();
                            } else {
                                initVideoSrcFnH5();
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    lazyHook: 3.5,
                });
            };
            resizeAni();
            return () => {
                if (videoSceneE) {
                    AniContainer.removeScene(videoSceneE);
                    videoSceneE = null;
                }
                if (textSceneE) {
                    AniContainer.removeScene(textSceneE);
                    textSceneE = null;
                }
            };
        }
    }, []);

    return (
        <section className={`effortlessly-box ${styles.effortlessly}`} style={{ height: innerHeight * 5.5 }}>
            <div className="sticky-box">
                <div
                    className={`video-box${isEnterA ? ' isEnterA' : ''}${isEnterA2 ? ' isEnterA2' : ''}${isEnterB ? ' isEnterB' : ''}${
                        isEnterB2 ? ' isEnterB2' : ''
                    }${isEnterC ? ' isEnterC' : ''}`}
                >
                    {/* <EFVideo
                        ref={videoRefPC}
                        // sources={['/video/effortlessly_1.mp4', '/video/effortlessly_1.mp4']}
                        className="video pc"
                        muted
                        // id="dpu-detail-E-video-pc"
                        autoPlay={false}
                        loop={false}
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                    /> */}
                    {/* <EFVideo
                        ref={videoRefH5}
                        className="video h5"
                        muted
                        // id="dpu-detail-E-video-h5"
                        // sources={['/video/effortlessly_1_h5.mp4', '/video/effortlessly_1_h5.mp4']}
                        autoPlay={false}
                        loop={false}
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                    /> */}
                    <video
                        ref={videoRefPC}
                        className="video pc"
                        muted
                        // id="dpu-detail-E-video-h5"
                        // src={'/video/effortlessly_1_h5.mp4'}
                        // loop
                        autoPlay={false}
                        // sources={[handleDynamicPath('/video/effortlessly_1_h5.mp4'), handleDynamicPath('/video/effortlessly_1_h5.mp4')]}
                        // autoPlay={false}
                        // loop={false}
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                    />
                    <video
                        ref={videoRefH5}
                        className="video h5"
                        muted
                        // id="dpu-detail-E-video-h5"
                        // src={'/video/effortlessly_1_h5.mp4'}
                        // loop
                        autoPlay
                        // sources={[handleDynamicPath('/video/effortlessly_1_h5.mp4'), handleDynamicPath('/video/effortlessly_1_h5.mp4')]}
                        // autoPlay={false}
                        // loop={false}
                        preload="auto"
                        width="100%"
                        height="100%"
                        playsInline
                    />
                    <div className={`textBox ${isEnterA ? 'textBoxA' : ''} ${isEnterB ? 'textBoxB' : ''} ${isEnterC ? 'textBoxC' : ''}`}>
                        <div className="text-ani text1">
                            <p className="title">{t('text1')}</p>
                        </div>
                        <div className="text-ani text2">
                            <p className="title">{t('text2')}</p>
                        </div>
                        <div className="text-ani text3">
                            <p className="subtitle">{t('label')}</p>
                            <h2 className="title">{t('title')}</h2>
                            <p className="desc">{t('desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
